const SALON = "GREEN Professionals Salon & Academy";
const LOCATION = "Near R.K. Sweets, Jandi Mandir Rd, Ashok Nagar (Subhash Chowk), Sonipat, Haryana";
export const MANAGER_WHATSAPP = "917056749191";

const waNumber = (phone) => {
  const digits = (phone || "").replace(/\D/g, "");
  return digits.length === 10 ? "91" + digits : digits;
};

export const openWhatsApp = (phone, text) => {
  window.open(`https://wa.me/${waNumber(phone)}?text=${encodeURIComponent(text)}`, "_blank", "noopener");
};

export const appointmentConfirmMsg = (a) =>
  `💇‍♂️ *Appointment Confirmed!*

Hello ${a.customer_name},
Your upcoming appointment at ${SALON} is locked in! Here are your details:

🗓️ Date: ${a.date}
⏰ Time: ${a.time}
✂️ Service: ${a.service_name}
👑 Stylist: ${a.staff_name}
${a.advance_amount ? `💵 Advance received: ₹${a.advance_amount.toLocaleString("en-IN")} (${a.advance_method || "Cash"})
` : ""}📍 Location: ${LOCATION}

If you need to reschedule, please let us know at least 4 hours in advance. See you soon!`;

const billStaff = (b) => {
  const names = [...new Set(b.items.flatMap((it) => (it.staff_name || "").split(", ")).filter(Boolean))];
  return names.join(", ") || "Our team";
};

export const billReceiptMsg = (b) =>
  `✨ *Thank you for visiting us!*

Hi ${b.customer_name},
Here is the summary of your visit today at ${SALON}:

🧾 Invoice No: ${b.invoice_no}
💇‍♂️ Attended By: ${billStaff(b)}
💰 Total Amount: ₹${b.total.toLocaleString("en-IN")}
💳 Paid Via: ${b.payment_method}
${b.points_earned ? `⭐ Reward Points Earned: ${b.points_earned}
` : ""}⚠️ Pending Balance: ₹${(b.paid ? 0 : b.balance_due ?? 0).toLocaleString("en-IN")}${b.due_date && !b.paid ? ` (due by ${b.due_date})` : ""}

📝 Stylist Note: Your service details have been securely saved to your profile for your next visit!

Have a beautiful day!`;

export const lowStockMsg = (p) =>
  `⚠️ *INVENTORY ALERT*

Attention Management,
The following product has fallen below its safe stock limit:

📦 Product: ${p.brand ? p.brand + " " : ""}${p.name}
🔢 Current Stock: ${p.stock} ${p.unit}
🚨 Minimum Required: ${p.low_stock_level} ${p.unit}

Please review and reorder from your supplier.`;
